module.exports = __webpack_public_path__ + "static/media/logo.6ac94932.svg";